// Legacy UiDeleteDialog's default picture (components/ui/UiDeleteDialog.vue `deleteIcon`): BO_DELETE_CONFIRMATION, and
// BO_DELETE_CONFIRMATION_DARK in dark mode (B1569). Every deleteDialog shows it unless the caller names its own icon, as
// Categories does (always the light pictures, even in dark).
export const DELETE_PICTURE = {
  illustration: '/assets/bo_delete_confirmation.svg',
  darkIllustration: '/assets/bo_delete_confirmation_dark.svg',
} as const;
